import React, { useState, useRef, useEffect } from "react";

const VISUALIZATION_OPTIONS = [
  { id: "LINE", label: "Line chart" },
  { id: "BAR", label: "Bar chart" },
  { id: "KPI", label: "KPI (Numeric summary)" }
];

const VisualizationTypePopover = ({ visualization, defaultVisualization = "LINE", onClose, onSave }) => {
  const [selected, setSelected] = useState(visualization || defaultVisualization);
  const ref = useRef(null);

  useEffect(() => {
    const handler = e => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  const handleSave = () => {
    onSave(selected);
    onClose();
  };

  return (
    <div ref={ref} className="audienceScopePopover visualizationTypePopover">
      <p className="audienceScopePopoverTitle">Visualization type</p>
      <div className="audienceScopeOptions">
        {VISUALIZATION_OPTIONS.map(opt => (
          <div
            key={opt.id}
            className={`audienceScopeOption${selected === opt.id ? " audienceScopeOptionActive" : ""}`}
            onClick={() => setSelected(opt.id)}
          >
            <span className="audienceScopeOptionRadio" />
            <div>
              <p className="audienceScopeOptionLabel">{opt.label}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="audienceScopeFooter">
        <button type="button" className="audienceScopeCancelBtn" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="audienceScopeSaveBtn" onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
};

export default VisualizationTypePopover;
